module.exports = __webpack_public_path__ + "static/pabbly-connect-792fcedc35b8ab68d022ebe50c824fb9.svg";